"use strict";

window.vblogger = window.vblogger || {};
window.vblogger.speedClickCounter = 1;
window.vblogger.popUp = document.querySelector('#mailFormPopUp');
window.vblogger.postShare = document.querySelector('img.share_btn');
window.vblogger.videoPlayer = document.querySelector('video');
window.vblogger.playerSpeed = document.querySelector('img.player_speed_btn');
window.vblogger.homePage = document.querySelector('.post-feed');

var dynamicPath = function () {
    var path = document.location.pathname;
    if (path.includes('/')) {
        var splitPath = path.split('/');
        path = splitPath[splitPath.length - 2];
    }
    return '/' + path + '/';
}();

const sendMessage = document.querySelector('#comments_input_holder #send');
const sendEmail = document.querySelector('#email_holder #send');
const viewsElm = document.querySelector('.byline-meta-views');
const likeElm = document.querySelector('.byline-meta-like');
const dislikeElm = document.querySelector('.byline-meta-dislike');
const likeBtn = document.querySelector('.byline-like');
const dislikeBtn = document.querySelector('.byline-dislike');


function sendEvent(event) {
    fetch(`https://data.wearefree.tv/analytics/${event}/${vblogger.uid}`).then(result => {
        console.log('sendEvent :', result.status);
    }).catch(error => {
        console.error('sendEvent Error:', error);
    });
}

vblogger.sendGA = function (action) {
    if (gtag) {
        gtag('event', 'click', {
            'value': action
        });
    }

    sendEvent(action);
}


function handleMood(event) {
    var path = event.path || (event.composedPath && event.composedPath());
    var type = path[0].className.includes('dislike') ? 'dislike' : 'like';

    vblogger.sendGA(type);

    if (window.vblogger.homePage) {
        let span = path[4].querySelector('.bull-views');
        dynamicPath = span.getAttribute('data-post-url');
    }

    fetch('https://data.wearefree.tv/' + type + dynamicPath).then(function (response) {
        return response.json();
    }).then(function (json) {
        console.log(json);
        likeElm.innerText = json.views.like;
        dislikeElm.innerText = json.views.dislike;
    });
}

function getViewsData() {

    vblogger.viewsDataSets = document.querySelectorAll("span[data-post-url]");
    var postUrls = [];

    if (document.location.pathname.includes('/en/')) {
        vblogger.viewsDataSets.forEach(function (set) {
            postUrls.push(set.dataset.postUrl.split('/')[2]);
        });
    } else {
        vblogger.viewsDataSets.forEach(function (set) {
            postUrls.push(set.dataset.postUrl.split('/')[1]);
        });
    }

    vblogger.postUrls = postUrls;
    var dataObjRaw = {};
    var dataObjLike = {};
    var dataObjDislike = {};

    fetch('https://data.wearefree.tv/views').then(function (response) {
        return response.json();
    }).then(function (data) {

        var again = document.querySelectorAll('.bull-views');


        data.views = data.views.filter(function (d) {
            if (d.id) {
                return !d.id.includes('wearefree.tv');
            }
        });

        data.views.forEach(function (item) {
            dataObjRaw[item.id] = item.count;
            dataObjLike[item.id] = item.like;
            dataObjDislike[item.id] = item.dislike;
        });

        function addData(span, url) {
            if (!span.innerText) {
                span.innerText = dataObjRaw[url];

                var like = span.offsetParent.querySelector('.byline-meta-like');
                var dislike = span.offsetParent.querySelector('.byline-meta-dislike');

                if (dataObjLike[url] > 0) {
                    like.innerText = dataObjLike[url];
                }
                if (dataObjDislike[url] > 0) {
                    dislike.innerText = dataObjDislike[url];
                }

            }
        }

        postUrls.forEach(function (url) {
            if (dataObjRaw[url]) {

                again.forEach(function (span) {
                    var spansUrl = span.getAttribute('data-post-url');
                    if (document.location.pathname.includes('/en/')) {
                        if (spansUrl.split('/')[2] == url) {
                            addData(span, url);
                        }
                    } else if (spansUrl.split('/')[1] == url) {
                        addData(span, url)
                    }
                });
            }
        });
    });
}

if (window.vblogger.postShare && navigator.share) {
    window.vblogger.postShare.addEventListener('click', function () {
        vblogger.sendGA('share');
        window.vblogger.postCardTitle = document.querySelector('.post-full-header h1.post-full-title');
        window.vblogger.postContent = document.querySelector('.post-full-header h1.post-full-custom-excerpt');
        if (navigator.share) {
            navigator.share({
                title: window.vblogger.postCardTitle.innerText,
                text: window.vblogger.postContent ? window.vblogger.postContent.innerText : document.location.title,
                url: document.location.href + '?referral=site'
            }).then(function () {
                return console.log('Successful share');
            }).catch(function (error) {
                return console.log('Error sharing', error);
            });
        }
    });
} else if (window.vblogger.postShare) {
    window.vblogger.postShare.style.display = 'none';
}

if (vblogger && vblogger.popUpEmailer) {
    var closePopUpEmail = function closePopUpEmail() {
        if (window.vblogger.popUp) window.vblogger.popUp.style.display = 'none';
        document.cookie = vblogger.popUp_cookie_name + '=true';
    };

    if (window.vblogger.popUp) window.vblogger.popUp.style.display = 'block';

    var popUpBtn = document.querySelector(".mailFormPopUp_header h2");
    vblogger.popUp_cookie_name = 'wearefreetv_accepted';
    vblogger.cookies = document.cookie.split(';');

    vblogger.popUp_cookie = vblogger.cookies.filter(function (item) {
        return item.indexOf(vblogger.popUp_cookie_name) !== -1;
    });

    if (vblogger.popUp_cookie.length > 0) {
        closePopUpEmail();
    }

    if (popUpBtn) popUpBtn.addEventListener('click', closePopUpEmail);

    (function (d, s, id) {
        var js,
            fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = "//forms.aweber.com/form/91/1714363791.js";
        fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "aweber-wjs-ifv8yfi28");
}

if (window.vblogger.videoPlayer) {

    window.vblogger.playerSpeed.style.display = "initial";
    window.vblogger.playerSpeed.addEventListener('click', function (event) {
        window.vblogger.speedClickCounter = window.vblogger.speedClickCounter + 0.25;

        window.vblogger.videoPlayer.playbackRate = window.vblogger.speedClickCounter;
        window.vblogger.playerSpeed.style.background = 'green';

        if (window.vblogger.speedClickCounter === 1.5) {
            window.vblogger.playerSpeed.style.background = 'yellow';
        }
        if (window.vblogger.speedClickCounter > 1.5) {
            window.vblogger.playerSpeed.style.background = 'red';
        }

        if (window.vblogger.speedClickCounter > 1.75) {
            window.vblogger.speedClickCounter = 1;
            window.vblogger.playerSpeed.style.background = '#fff';
            window.vblogger.videoPlayer.playbackRate = window.vblogger.speedClickCounter;
        }
    });
}

if (!window.vblogger.homePage) {
    if (likeBtn) {

        likeBtn.addEventListener('click', handleMood, {once: true});
    }
    if (dislikeBtn) {
        dislikeBtn.addEventListener('click', handleMood, {once: true});
    }
}

// let commentsOutputElm = document.querySelector('.comments_section');

if (window.vblogger.homePage) {

    getViewsData();

    // var likeBtns = document.querySelectorAll('.byline-like');
    // var dislikeBtns = document.querySelectorAll('.byline-dislike');

    // likeBtns.forEach(function (btn) {
    //     btn.addEventListener('click', handleMood);
    // });

    // dislikeBtns.forEach(function (btn) {
    //     btn.addEventListener('click', handleMood);
    // });

    fetch('https://data.wearefree.tv/counter' + '/www.wearefree.tv').then(function (response) {
        return response.json();
    }).then(function (json) {
    });
}

// send view event per post
if (viewsElm) {

    // if (document.location.pathname.includes('/tag/')) {

    fetch('https://data.wearefree.tv/counter' + dynamicPath).then(function (response) {
        return response.json();
    }).then(function (json) {
        viewsElm.innerText = json.views.count;
        likeElm.innerText = json.views.like;
        dislikeElm.innerText = json.views.dislike;
    });

    // } else {
    //     fetch('https://data.wearefree.tv/counter' + dynamicPath).then(function (response) {
    //         return response.json();
    //     }).then(function (json) {
    //         viewsElm.innerText = json.views.count;
    //     });
    // }
}

if (sendMessage) {
    (function () {
        var addComment = function addComment(json) {

            try {
                (function () {
                    var sortedData = json.body.filter(function (json) {
                        return json.date;
                    });
                    var data = json.body;
                    var messageText = '<p class="message_name">';
                    var messagedName = void 0;
                    var HTML_Blob = [];
                    // console.log('filtered, ', sortedData);

                    sortedData.sort(function (a, b) {
                        if (a.date && b.date) {
                            return a.date - b.date;
                        }
                    });

                    (sortedData || data).map(function (msg) {
                        messagedName = '<p class="message_name">' + msg.comment.name + ':</p>';
                        messageText = '<p class="message_text">' + msg.comment.value + '</p>';
                        HTML_Blob.push(messagedName);
                        HTML_Blob.push(messageText);
                        // return [messagedName,messageText]
                    });
                    // console.log(HTML_Blob.join(''));
                    commentsElm.innerHTML = HTML_Blob.join('');
                })();
            } catch (e) {
                console.log(e);
            }
        };

        var messageSend = function messageSend() {


            nameElm.placeholder = 'שם';
            nameElm.value = '';
            messageElm.placeholder = 'תגובה';
            messageElm.value = '';

            sendMessage.classList.add('disabled');
            sendMessage.innerHTML = 'נשלח...';
            setTimeout(function () {
                sendMessage.classList.remove('disabled');
                sendMessage.innerHTML = 'שלח/י';
            }, 5000);
        };

        // let messageElm = document.querySelector('#comments_input').value = 'תוסיפו תגובה...'
        var commentsElm = document.querySelector('#comments_section');
        var messageElm = document.querySelector('#comments_input');
        var nameElm = document.querySelector('#comments_name');

        fetch('https://data.wearefree.tv/post' + dynamicPath).then(function (response) {
            return response.json();
        }).then(function (json) {
            const domElement = document.querySelector('#comments_title');
            domElement.innerHTML =
                `${json.body.length} תגובות <span>   הוסף תגובה: </span>`;
            addComment(json);
        });

        sendMessage.addEventListener('click', function () {
            vblogger.sendGA('comment');

            var nameLength = document.querySelector('#comments_name').value.length;

            var name = nameElm.value;
            var message = messageElm.value;

            if (nameLength >= 25) {
                nameElm.value = 'מקסימום 25 תווים...';
                return;
            }

            if (!name) {
                nameElm.placeholder = 'שדה חובה...';
            }
            if (!message) {
                messageElm.placeholder = 'שדה חובה...';
            }

            if (message && name && nameLength < 25) {
                var data = dynamicPath + 'who/' + encodeURIComponent(name) + '/comment/' + encodeURIComponent(message);
                fetch('https://data.wearefree.tv/post' + data).then(function (response) {
                    return response.json();
                }).then(function (json) {
                    messageSend();
                    addComment(json);
                });
            }
        });
    })();
}

function searchFeature() {
    vblogger.allTags = [];
    vblogger.allSearchablePosts = [];
    let searched = [], searchedPosts = [];

    searchFeature.mobile = () => {
        if (window.screen.orientation) {
            return window.screen.orientation.type.includes('portrait') && window.innerWidth < 480;
        } else {
            return window.innerWidth < 480;
        }
    }

    searchFeature.searchContainerDom = document.querySelector('#search');
    searchFeature.searchBtn = document.querySelector('#searchBtn');
    searchFeature.searchedPostsList = document.querySelector('#searchResults ul');
    searchFeature.searchResultsContainer = document.querySelector('#searchResults');
    searchFeature.closeBtn = document.querySelector('#searchResults #closeList');

    if (searchFeature.mobile()) {
        let mobileNav = document.querySelector('.site-home-header') || document.querySelector('.site-archive-header');
        searchFeature.searchContainerDom = mobileNav.querySelector('#search');
        searchFeature.searchBtn = mobileNav.querySelector('#searchBtn');
        searchFeature.searchedPostsList = mobileNav.querySelector('#searchResults ul');
        searchFeature.searchResultsContainer = mobileNav.querySelector('#searchResults');
        searchFeature.closeBtn = mobileNav.querySelector('#searchResults #closeList');
    }

    function setSearchDom() {
        if (!searchFeature.mobile()) {
            let navPlace = document.querySelector('nav ul>li').getBoundingClientRect().right.toString();
            searchFeature.searchContainerDom.style.left = navPlace - 390 + 'px';
            searchFeature.searchContainerDom.style.display = 'block'
        }
    }

    function getServerTags() {
        if (vblogger.allTags.length) {
            return vblogger.allTags;
        }
        return new Promise((resolve, reject) => {
            fetch('//www.wearefree.tv/ghost/api/v3/content/tags/?key=86ada218ec30f07f1f44985d57&limit=all&filter=visibility:public').then(function (response) {
                return response.json();
            }).then(function (data) {
                vblogger.allTags = data.tags;
                resolve(data.tags);
            });

        });
    }

    function getServerPosts() {
        if (vblogger.allSearchablePosts.length) {
            return vblogger.allSearchablePosts;
        }
        return new Promise((resolve, reject) => {
            fetch('//www.wearefree.tv/ghost/api/v3/content/posts/?key=86ada218ec30f07f1f44985d57&filter=tag:-en,tag:-ru,visibility:public&limit=all&version=v3&fields=title,url').then(function (response) {
                return response.json();
            }).then(function (data) {
                vblogger.allSearchablePosts = data.posts;
                resolve(data.posts);
            });
        });
    }

    function handleCloseBtn(elm) {
        vblogger.sendGA('search_close');
        searchFeature.searchResultsContainer.style.display = 'none';
    }

    function handleSearch() {
        vblogger.sendGA('search');

        const searchParams = searchFeature.searchInput.value;
        console.debug('searchParams', searchParams);

        if (searchParams.length) {
            Promise.all([getServerTags(), getServerPosts()]).then((data) => {

                // hide previous searches
                if (searchFeature.searchedPostsList.childNodes) {
                    searchFeature.searchedPostsList.innerHTML = '';
                }

                searched = data[0].filter((tag) => {
                    return tag.name.includes(searchParams);
                });

                searchedPosts = data[1].filter((tag) => {
                    return tag.title.includes(searchParams);
                });

                if (searched.length) {
                    searchFeature.searchResultsContainer.style.display = 'block';
                    searchFeature.searchedPostsList.innerHTML += `<p class="search_tags">תגיות:</p>`
                    searched.map(item => {
                        searchFeature.searchedPostsList.innerHTML += `<li><div><a href='${item.url}'>${item.name}</a></div></li>`
                    })
                }

                if (searchedPosts.length) {
                    searchFeature.searchResultsContainer.style.display = 'block';
                    if (searched.length) {
                        searchFeature.searchedPostsList.innerHTML += `<hr>`
                    }
                    searchFeature.searchedPostsList.innerHTML += `<p class="search_tags">פוסטים:</p>`
                    searchedPosts.map(item => {
                        searchFeature.searchedPostsList.innerHTML += `<li><div><a href='${item.url}'>${item.title}</a></div></li>`
                    })
                }

                if (searched.length === 0 && searchedPosts.length === 0) {
                    searchFeature.searchResultsContainer.style.display = 'block';
                    searchFeature.searchedPostsList.innerHTML += `<p>לא נמצא</p>`
                }

                searchFeature.closeBtn.addEventListener('click', handleCloseBtn);

                console.debug('promise data', data);
                console.debug('search:', searched);
                console.debug('searchedPosts:', searchedPosts);

            })
        }
    }

    window.addEventListener('DOMContentLoaded', () => {

        if (searchFeature.mobile()) {
            searchFeature.mobileNav = document.querySelector('#search');
            if (searchFeature.mobileNav) {
                searchFeature.searchInput = searchFeature.mobileNav.querySelector('input#searchTags');
                searchFeature.searchBtn = searchFeature.mobileNav.querySelector('#searchBtn');
            }
        } else {
            searchFeature.searchInput = document.querySelector('input#searchTags');
        }

        if (searchFeature.searchInput) {
            setSearchDom();
            searchFeature.searchBtn.addEventListener('click', handleSearch)
        }
    })

}

searchFeature();



